export const SHOW_VALIDATED_MNEMONICS = 'SHOW_VALIDATED_MNEMONICS'
export const SHOW_VALIDATED_MNEMONICS_SCREEN = 'SHOW_VALIDATED_MNEMONICS_SCREEN'
export const SHOW_CREATE_WALLET_SCREEN = 'SHOW_CREATE_WALLET_SCREEN'
export const SHOW_COPY_MNEMONCIS_SCREEN = "SHOW_COPY_MNEMONCIS_SCREEN"
export const SHOW_RANDOM_MNEMONICS_SCREEN = "SHOW_RANDOM_MNEMONICS_SCREEN"
export const USER_WALLET_LIST = "USER_WALLET_LIST"
export const SHOW_SHOP_REGISTER_SCREEEN = "SHOW_SHOP_REGISTER_SCREEEN"
